import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import './SideNav.scss';
import logo from '../../../assets/logo.jpg';
import { colors } from '../../../common/constants/colors.constants';
import { Link, useLocation } from 'react-router';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import DevicesIcon from '@mui/icons-material/Devices';
import LayersIcon from '@mui/icons-material/Layers';
import {DEVICE, FLOOR_PLANS_BASE, HALLS, HOME_PAGE} from "../../../common/constants/routes.constants";

const NAVIGATION = [
  {
    sectionTitle: '',
    sectionContent: [
      {
        label: 'SAJMOVI',
        route: HOME_PAGE,
        icon: <AccountBalanceIcon />,
      },
      {
        label: 'HALE',
        route: HALLS,
        icon: <SpaceDashboardIcon />,
      },
      {
        label: 'OSNOVE PROSTORNIH PLANOVA',
        route: FLOOR_PLANS_BASE,
        icon: <LayersIcon />,
      },
      {
        label: 'UREĐAJI',
        route: DEVICE,
        icon: <DevicesIcon />,
      },
    ],
  },
];

export default function SideNav() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [openSections, setOpenSections] = useState<string[]>([]);

  useEffect(() => {
    NAVIGATION.forEach((section) => {
      section.sectionContent.forEach((navItem) => {
        if (navItem.route === location.pathname) {
          setActiveTab(navItem.label);
        }
      });
    });
  }, [location.pathname]);

  const toggleSection = (sectionTitle: string) => {
    if (openSections.includes(sectionTitle)) {
      setOpenSections(openSections.filter((title) => title !== sectionTitle));
    } else {
      setOpenSections([...openSections, sectionTitle]);
    }
  };

  return (
    <Box
      component="nav"
      sx={{ width: 280, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
      className="side-nav"
    >
      <Drawer
        variant="permanent"
        open
        className="side-nav__drawer"
        PaperProps={{
          sx: {
            backgroundColor: colors.neutral[800],
            color: colors.neutral[300],
            width: '280px',
          },
        }}
      >
        <Stack direction="row" alignItems="center" className="side-nav__header">
          <Box className="side-nav__header-logo">
            <img width={30} height={30} src={logo} alt="logo" />
          </Box>
          <h6 className="side-nav__title">Sajam Navigator Admin</h6>
        </Stack>
        <Stack spacing={2} className="side-nav__list">
          {NAVIGATION.map((navSection, sectionIndex) => (
            <Box key={sectionIndex} className="side-nav__section">
              <Box
                component="span"
                className="side-nav__section-title"
                onClick={() => toggleSection(navSection.sectionTitle)}
              >
                {navSection.sectionTitle}
              </Box>
              <Stack
                spacing={1}
                className={`side-nav__section-content ${
                  openSections.includes(navSection.sectionTitle) ? 'open' : ''
                }`}
              >
                {navSection.sectionContent.map((navItem, index) => (
                  <Link
                    to={navItem.route ?? '/'}
                    key={index}
                    className={`side-nav__list-item ${
                      activeTab === navItem.label ? 'active' : ''
                    }`}
                  >
                    {navItem.icon}
                    {navItem.label}
                  </Link>
                ))}
              </Stack>
            </Box>
          ))}
        </Stack>
      </Drawer>
    </Box>
  );
}
